import { render } from "./ContractApprenticeBlockComponent.vue?vue&type=template&id=7ad9f8f4"
import script from "./ContractApprenticeBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractApprenticeBlockComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__